export default __webpack_public_path__ + "static/media/icon-bel-m.3e71c1be.svg";